<template>
    <div class="card mb-3" style="width: 60rem;">
        <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="(survey, surveyIndex) in surveys">
                <h5 class="card-title">{{survey['question']}}</h5>
                <div class="form-check" v-for="(choice, choiceIndex) in survey['choices']">
                    <input class="form-check-input" type="radio"
                           :name="surveyIndex"
                           :id="surveyIndex + '_' + choiceIndex"
                           value="option1"
                            v-on:click="buildData(survey, surveyIndex, choiceIndex)">
                    <label class="form-check-label col-md-2" :for="surveyIndex + '_' + choiceIndex">
                        {{choice.text}}
                    </label>
                </div>
            </li>
        </ul>

        <div class="card-footer">
            <a href="#" class="btn btn-primary" v-on:click="submitSurvey">Submit</a>
        </div>
    </div>
</template>

<script>
    import Qs from 'qs';
    export default {
        name: 'survey-questionnaire-view',
        props: ['surveys'],
        data() {
            return {
                data: [],
            }
        },
        methods: {
            buildData(survey, surveyIndex, choiceIndex) {
                survey['choices'].forEach((choice, cIndex) => {
                    survey['choices'][cIndex]['is_checked'] = false;
                });

                survey['choices'][choiceIndex]['is_checked'] = true;
                this.data[surveyIndex] = survey;
            },
            submitSurvey() {
                let url = window.env.baseUri + 'survey/save-survey-response';
                return axios.post(url,  Qs.stringify(this.data)).then(() => {
                    window.location.replace(window.env.baseUri + "survey/thanks");
                });
            },
        }
    };
</script>

<style scoped>
a {
    width: 100px;
}

.card-title {
    font: bold 22px Verdana, Courier, sans-serif;
}

.form-check {
    font: 18px Verdana, Courier, sans-serif;
}

.form-check-label {
    text-align: left;
}

</style>